import React, {Component} from "react";
import IconButton from '@material-ui/core/IconButton';
import GroupIcon from '@material-ui/icons/Group';
import SettingsIcon from '@material-ui/icons/SettingsRounded';
import SlideshowIcon from '@material-ui/icons/SlideshowRounded';
import EqualizerIcon from '@material-ui/icons/EqualizerRounded';
import ReportsIcon from '@material-ui/icons/DescriptionRounded';
import EditLocationIcon from '@material-ui/icons/EditLocationRounded';
import NewReleaseIcon from '@material-ui/icons/NewReleasesRounded';
import './TopToolbar.scss';
import LogoImage from "../../../../resources/images/ShipitLogo.png";
import DemoLogoImage from "../../../../resources/images/ShipitDemo.png";
import DefineShiftDialogContainer from "../../../Redux/containers/DefineShiftDialogContainer";
import DefineAvailablityDialogContainer from "../../../Redux/containers/DefineAvailabilityDialogContainer";
import SettingsDialogContainer from "../../../Redux/containers/SettingsDialogContainer";
import DemoDialogContainer from "../../../Redux/containers/DemoDialogContainer";
import {eventsSubject} from "../../../Events/events";
import {filter} from "rxjs/operators";
import {OpenDemoDialogTopic} from "../../../Events/topics";
import UsersDialogContainer from "../../../Redux/containers/UsersDialogContainer";
import KibanaDialogContainer from "../../../Redux/containers/KibanaDialogContainer";
import * as permissionTypes from "../../../Utils/Permissions/PermissionTypes";
import {AppContext} from "../../Utils/AppContext";
import ShiftIcon from "../../../Utils/Icons/SVGs/ShiftIcon";
import LogoutIcon from "../../../Utils/Icons/SVGs/LogoutIcon";
import AvailableMessengersIcon from "../../../Utils/Icons/SVGs/AvailableMessengersIcon";
import ReportsDialog from "./ReportsDialog/ReportsDialog";
import axios from "axios"
import Typography from "@material-ui/core/Typography";
import NewReleaseDialog, {
    isReleaseNotesDialogEnabled,
    latestReleaseNotesVersion
} from "./NewReleaseDialog/NewReleaseDialog";
import cmp from "semver-compare";
import SlaQuickChangerContainer from "../../../Redux/containers/SlaQuickChangerContainer";
import AddressManualChangesDialog from "./AddressManualChangesDialog/AddressManualChangesDialog";


export default class TopToolbar extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            isDemoDialogOpen: false,
            isKibanaDialogOpen: false,
            isDefineShiftDialogOpen: false,
            isSettingsDialogOpen: false,
            isAvailabilityDialogOpen: false,
            isUsersDialogOpen: false,
            isReportsDialogOpen: false,
            isNewReleaseDialogOpen: false
        };

        this.unsub = eventsSubject
            .pipe(filter(f => f.topic === OpenDemoDialogTopic))
            .subscribe(s => this.openDemoDialog());
    }

    openReleaseNotesDialogIfShould() {
        let shouldOpenNewReleaseDialog = false;
        const lastVersionFromReleaseDialog = localStorage.getItem('lastNewReleaseDialogVersion');

        if (isReleaseNotesDialogEnabled && lastVersionFromReleaseDialog) {
            const newVerCurrVerComparison = cmp(latestReleaseNotesVersion, lastVersionFromReleaseDialog);

            shouldOpenNewReleaseDialog = newVerCurrVerComparison === 1;
        }

        if (lastVersionFromReleaseDialog !== latestReleaseNotesVersion)
            localStorage.setItem("lastNewReleaseDialogVersion", latestReleaseNotesVersion);

        if (shouldOpenNewReleaseDialog) {
            this.setState({
                isNewReleaseDialogOpen: true
            });

            this.props.logInfo("openNewReleaseDialog", this.context.bid,
                {openReason: "newVersion", version: latestReleaseNotesVersion});
            this.newReleaseDialogOpenReason = "newVersion";
            this.newReleaseDialogOpenTime = new Date();
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.openReleaseNotesDialogIfShould();
        }, 500);
    }

    componentWillUnmount() {
        this.unsub.unsubscribe();
    }

    openDefineMessengers = () => {
        this.setState({
            isDefineShiftDialogOpen: true
        });
    };

    openAvailableMessengersDialog = () => {
        this.setState({
            isAvailabilityDialogOpen: true
        });
    };

    openSettingsDialog = () => {
        this.setState({
            isSettingsDialogOpen: true
        });
    };

    openDemoDialog = () => {
        this.setState({
            isDemoDialogOpen: true
        });
    };

    openKibanaDialog = () => {
        const win = window.open(this.props.kibanaUrl, '_blank');
        win.focus();

        return;

        this.setState({
            isKibanaDialogOpen: true
        });
    };

    openUsersDialog = () => {
        this.setState({
            isUsersDialogOpen: true
        });
    };

    openNewReleaseDialog = () => {
        this.setState({
            isNewReleaseDialogOpen: true
        });

        this.props.logInfo("openNewReleaseDialog", this.context.bid,
            {openReason: "click", version: latestReleaseNotesVersion});
        this.newReleaseDialogOpenReason = "click";
        this.newReleaseDialogOpenTime = new Date();
    };

    openAddressesDialog = () => {
        this.setState({
            isAddressesDialogOpen: true
        });
    };

    openReportsDialog = () => {
        this.setState({
            isReportsDialogOpen: true
        });
    };

    closeNewReleaseDialog = () => {
        this.setState({
            isNewReleaseDialogOpen: false
        });

        this.props.logInfo("closeNewReleaseDialog", this.context.bid,
            {
                openReason: this.newReleaseDialogOpenReason,
                duration: (new Date() - this.newReleaseDialogOpenTime) / 1000,
                version: latestReleaseNotesVersion
            })
        this.newReleaseDialogOpenReason = undefined;
        this.newReleaseDialogOpenTime = undefined;
    };

    closeReportsDialog = () => {
        this.setState({
            isReportsDialogOpen: false
        });
    };

    closeAddressesDialog = () => {
        this.setState({
            isAddressesDialogOpen: false
        });
    };

    closeAvailabilityDialog = () => {
        this.setState({
            isAvailabilityDialogOpen: false
        });
    };

    closeShiftsDialog = () => {
        this.setState({
            isDefineShiftDialogOpen: false
        });
    };

    closeSettingsDialog = () => {
        this.setState({
            isSettingsDialogOpen: false
        });
    };

    closeKibanaDialog = () => {
        this.setState({
            isKibanaDialogOpen: false
        });
    };

    closeDemoDialog = () => {
        this.setState({
            isDemoDialogOpen: false
        });
    };

    closeUsersDialog = () => {
        this.setState({
            isUsersDialogOpen: false
        });
    };

    logout = async () => {
        const {data} = await axios.post('/api/v2/users/logout');

        if (data.isLoggedOut)
            window.location.href = "/login";
    };

    render() {
        return (
            <div>
                <div className="app-bar">
                    <div className="title-container">
                        <div className="title-container-1">
                            <div className="title">
                                <img src={this.props.isDemo ? DemoLogoImage : LogoImage}/>
                            </div>
                        </div>
                    </div>
                    <div className="sla-container">
                        <SlaQuickChangerContainer/>
                    </div>
                    <div className="buttons">
                        {
                            isReleaseNotesDialogEnabled
                                ?
                                <IconButton className="toolbar-button toolbar-update-button"
                                            onClick={this.openNewReleaseDialog.bind(this)}>
                                    <div className="toolbar-button-content">
                                        <div className="toolbar-button-icon new-release-button-icon">
                                            <NewReleaseIcon style={{"fontSize": "32px"}}/>
                                        </div>
                                        <Typography className="toolbar-button-text">
                                            עדכונים
                                        </Typography>
                                    </div>
                                </IconButton>
                                :
                                null
                        }
                        {
                            !this.props.isAutopilot && this.context.permissions.isPermitted(permissionTypes.UPDATE_SHIFT_MEMBERS_AVAILABILITY) ?
                                <IconButton className="toolbar-button"
                                            onClick={this.openAvailableMessengersDialog.bind(this)}>
                                    <div className="toolbar-button-content">
                                        <div className="toolbar-button-icon">
                                            <AvailableMessengersIcon fontSize="37px"/>
                                        </div>
                                        <Typography className="toolbar-button-text">
                                            זמינות ({this.props.numberOfAvailableMessengers})
                                        </Typography>
                                    </div>
                                </IconButton>
                                :
                                false
                        }
                        {
                            !this.props.isAutopilot && this.context.permissions.isPermitted(permissionTypes.UPDATE_SHIFT_MEMBERS) ?
                                <IconButton className="toolbar-button"
                                            onClick={this.openDefineMessengers.bind(this)}>
                                    <div className="toolbar-button-content">
                                        <div className="toolbar-button-icon">
                                            <ShiftIcon fontSize="27px"/>
                                        </div>
                                        <Typography className="toolbar-button-text">
                                            משמרת ({this.props.numberOfMessengersOnShift})
                                        </Typography>
                                    </div>
                                </IconButton>
                                :
                                false
                        }
                        {
                            this.context.permissions.isPermitted(permissionTypes.ADD_EDIT_REMOVE_USERS) ?
                                <IconButton className="toolbar-button"
                                            onClick={this.openUsersDialog.bind(this)}>
                                    <div className="toolbar-button-content">
                                        <div className="toolbar-button-icon">
                                            <GroupIcon style={{"fontSize": "32px"}}/>
                                        </div>
                                        <Typography className="toolbar-button-text">
                                            עובדים
                                        </Typography>
                                    </div>
                                </IconButton>
                                :
                                false
                        }
                        {
                            this.props.kibanaUrl && this.context.permissions.isPermitted(permissionTypes.VIEW_STATISTICS) ?
                                <IconButton className="toolbar-button"
                                            onClick={this.openKibanaDialog.bind(this)}>
                                    <div className="toolbar-button-content">
                                        <div className="toolbar-button-icon">
                                            <EqualizerIcon style={{"fontSize": "32px"}}/>
                                        </div>
                                        <Typography className="toolbar-button-text">
                                            אנליטיקות
                                        </Typography>
                                    </div>
                                </IconButton>
                                :
                                false
                        }
                        {
                            this.context.permissions.isPermitted(permissionTypes.VIEW_REPORTS) ?
                                <IconButton className="toolbar-button"
                                            onClick={this.openReportsDialog.bind(this)}>
                                    <div className="toolbar-button-content">
                                        <div className="toolbar-button-icon">
                                            <ReportsIcon style={{"fontSize": "32px"}}/>
                                        </div>
                                        <Typography className="toolbar-button-text">
                                            דו״חות
                                        </Typography>
                                    </div>
                                </IconButton>
                                :
                                false
                        }
                        {
                            this.context.permissions.isPermitted(permissionTypes.VIEW_MANUAL_ADDRESS_CACHE) ?
                                <IconButton className="toolbar-button"
                                            onClick={this.openAddressesDialog.bind(this)}>
                                    <div className="toolbar-button-content">
                                        <div className="toolbar-button-icon">
                                            <EditLocationIcon style={{"fontSize": "32px"}}/>
                                        </div>
                                        <Typography className="toolbar-button-text">
                                            כתובות
                                        </Typography>
                                    </div>
                                </IconButton>
                                :
                                false
                        }
                        {
                            this.props.isDemo ?
                                <IconButton className="toolbar-button"
                                            onClick={this.openDemoDialog.bind(this)}>
                                    <div className="toolbar-button-content">
                                        <div className="toolbar-button-icon">
                                            <SlideshowIcon style={{"fontSize": "32px"}}/>
                                        </div>
                                        <Typography className="toolbar-button-text">
                                            מכסת משלוחים
                                        </Typography>
                                    </div>
                                </IconButton>
                                :
                                false
                        }
                        {
                            this.context.permissions.isPermitted(permissionTypes.EDIT_SETTINGS) ?
                                <IconButton className="toolbar-button"
                                            onClick={this.openSettingsDialog.bind(this)}>
                                    <div className="toolbar-button-content">
                                        <div className="toolbar-button-icon">
                                            <SettingsIcon style={{"fontSize": "32px"}}/>
                                        </div>
                                        <Typography className="toolbar-button-text">
                                            הגדרות
                                        </Typography>
                                    </div>
                                </IconButton>
                                :
                                false
                        }
                        <IconButton className="toolbar-button"
                                    onClick={this.logout.bind(this)}>
                            <div className="toolbar-button-content">
                                <div className="toolbar-button-icon">
                                    <LogoutIcon fontSize="27px"/>
                                </div>
                                <Typography className="toolbar-button-text">
                                    התנתק
                                </Typography>
                            </div>
                        </IconButton>
                    </div>
                </div>
                <NewReleaseDialog match={this.props.match}
                                  open={this.state.isNewReleaseDialogOpen}
                                  onClose={this.closeNewReleaseDialog.bind(this)}/>
                <ReportsDialog match={this.props.match}
                               open={this.state.isReportsDialogOpen}
                               onClose={this.closeReportsDialog.bind(this)}/>
                <AddressManualChangesDialog match={this.props.match}
                                            open={this.state.isAddressesDialogOpen}
                                            minAddressChangeRecommendationDialog={this.props.minAddressChangeRecommendationDialog}
                                            onClose={this.closeAddressesDialog.bind(this)}/>
                <DemoDialogContainer match={this.props.match}
                                     open={this.state.isDemoDialogOpen}
                                     onClose={this.closeDemoDialog.bind(this)}/>
                <DefineShiftDialogContainer match={this.props.match}
                                            open={this.state.isDefineShiftDialogOpen}
                                            onClose={this.closeShiftsDialog.bind(this)}/>
                <DefineAvailablityDialogContainer match={this.props.match}
                                                  open={this.state.isAvailabilityDialogOpen}
                                                  onClose={this.closeAvailabilityDialog.bind(this)}/>
                <SettingsDialogContainer match={this.props.match}
                                         open={this.state.isSettingsDialogOpen}
                                         onSave={this.closeSettingsDialog.bind(this)}
                                         onCancel={this.closeSettingsDialog.bind(this)}/>
                <UsersDialogContainer match={this.props.match}
                                      open={this.state.isUsersDialogOpen}
                                      onClose={this.closeUsersDialog.bind(this)}/>
                <KibanaDialogContainer match={this.props.match}
                                       open={this.state.isKibanaDialogOpen}
                                       onClose={this.closeKibanaDialog.bind(this)}/>
            </div>
        );
    }
}